export enum EnumTipoTrabalhoComanda {
    APENAS_CODIGO,
    APENAS_RFID,
    HIBRIDO
}